//ADD ALL MIXPANEL EVENT NAMES HERE

//FETCH SCOPE ERROR LOGGER
export const FETCH_SCOPE_ERROR = 'Fetch_Scope_Error';

//AUTHENTICATION EVENTS (LOGIN/LOGOUT)
export const LOGOUT_CLICKED = 'logout_Clicked';
export const LOGIN_USER = 'login_user';
export const LOGIN_USER_ERROR = 'login_user_error';
export const LOGIN_USER_SESSION_ERROR = 'login_user_session_error';
export const LOGOUT_USER = 'logout_user';
export const LOGOUT_CONFIRMATION_CLICKED = 'logout_confirmation_Clicked';

//GLOBAL FILTER EVENTS
export const GLOBAL_FILTER_ATTRIBUTE_EXPAND_COLLAPSE = 'GF_Attribute_Expand_Collapse';
export const GLOBAL_FILTER_TIME_SELECTION = 'GF_Time_Selection';
export const GLOBAL_FILTER_ATTRIBUTE_SELECTION = 'GF_Attribute_Selection';
export const GLOBAL_FILTER_EXPAND_COLLAPSE = 'GF_Expand_Collapse';
export const GLOBAL_FILTER_CLICK_INSIDE_EXPANDED_FILTER = 'GF_Click_Inside_Expanded_Filter';
export const GLOBAL_FILTER_SEARCH = 'GF_Attribute_Search';
export const GLOBAL_FILTER_APPLY_CLICKED = 'GF_Apply_Clicked';
export const GLOBAL_FILTER_RESET_CLICKED = 'GF_Reset_Clicked';

//GLOBAL NAVIGATION EVENTS
export const GLOBAL_NAV_NAVIGATION = 'GN_Navigation';
export const GLOBAL_NAV_HOVER = 'GN_Hover';
export const USER_MANUAL_CLICKED = 'GN_User_Manual_Clicked';
export const UPDATED_TILL_DATE_VIEWED = 'GN_Updated_Till_Date_Viewed';

//GROWTH ANALYSIS EVENTS
export const GROWTH_ANALYSIS_SUB_FILTER_CHANGED = 'GA_Global_Attribute_Changed';
export const GROWTH_ANALYSIS_SUB_FILTER_ADDED = 'GA_Global_Attribute_Added';
export const GROWTH_ANALYSIS_SUB_FILTER_DESELECTED = 'GA_Global_Attribute_Removed';
export const GROWTH_ANALYSIS_SALES_TAB_CHANGED = 'GA_Sales_Tab_Changed';
export const GROWTH_ANALYSIS_ABS_TAB_CHANGED = 'GA_Abs_Tab_Changed';
export const GROWTH_ANALYSIS_UNIT_DROPDOWN_CHANGED = 'GA_Unit_Dropdown_Changed';
export const GROWTH_ANALYSIS_CHART_COPY_CLICKED = 'GA_Chart_Copy';
export const GROWTH_ANALYSIS_TABLE_COPY_CLICKED = 'GA_Table_Copy';
export const GROWTH_ANALYSIS_CHART_EXPORT_CLICKED = 'GA_Chart_Export';
export const GROWTH_ANALYSIS_TABLE_EXPORT_CLICKED = 'GA_Table_Export';
export const GROWTH_ANALYSIS_COMPARE_CLICKED = 'GA_Global_Attribute_Compare_Toggled';
export const GROWTH_ANALYSIS_EXPANDED_CLICKED = 'GA_chart_Expanded_To_Table_Toggled';
export const GROWTH_ANALYSIS_RIGHT_CLICKED_ATTRIBUTE_SELECTED = 'GA_Chart_Right_Click_Dropdown_Attribute_Selected';
export const GROWTH_ANALYSIS_LEFT_CLICKED_DRILLDOWN = 'GA_Chart_Left_Click_Drilldown_Clicked';
export const GROWTH_ANALYSIS_EXPLORE_MORE_CLICKED = 'GA_Chart_Explore_More_Clicked';
export const GROWTH_ANALYSIS_SALES_CHART_FACTOR_CLICKED = 'GA_Sales_Chart_Factor_Clicked';
export const GROWTH_ANALYSIS_SALES_CHART_SUB_FACTOR_CLICKED = 'GA_Sales_Chart_Sub_Factor_Clicked';
export const GROWTH_ANALYSIS_SALES_CHART_SUB_FACTOR_TAB_CHANGED = 'GA_Sales_Chart_Sub_Factor_Tab_Changed';
export const GROWTH_ANALYSIS_SALES_CHART_SUB_FACTOR_DRILLDOWN_CLICKED = 'GA_Sales_Chart_Sub_Factor_Drilldown_Clicked';
export const GROWTH_ANALYSIS_SALES_CHART_SUB_FACTOR_DRILLDOWN_TAB_CHANGED =
    'GA_Sales_Chart_Sub_Factor_Drilldown_Tab_Changed';
export const GROWTH_ANALYSIS_SALES_CHART_SUB_FACTOR_DRILLDOWN_ATTRIBUTE_DROPDOWN_CHANGED =
    'GA_Sales_Chart_Sub_Factor_Drilldown_Attribute_Dropdown_Changed';

//BUMP REPORT EVENTS
export const BUMP_REPORT_MAIN_TAB_CLICKED = 'BR_Main_Tab_Changed';
export const BUMP_REPORT_ABS_TAB_CLICKED = 'BR_Abs_Tab_Changed';
export const BUMP_REPORT_VALUE_TAB_CLICKED = 'BR_Value_Tab_Changed';
export const BUMP_REPORT_BAR_SLIDER_CHANGE = 'BR_Bar_Chart_Time_Slider_Change';
export const BUMP_REPORT_DROPDOWN_CHANGE = 'BR_Chart_Dropdown_Change';
export const BUMP_REPORT_CHART_MICRO_INTERACTION = 'BR_Chart_Micro_Interaction';
export const BUMP_REPORT_CHART_COPY_CLICKED = 'BR_Chart_Copy';
export const BUMP_REPORT_CHART_EXPORT_CLICKED = 'BR_Chart_Export';
export const BUMP_REPORT_GROUPBY_DROPDOWN_CHANGE = 'BR_Chart_Groupby_Dropdown_Change';
export const BUMP_REPORT_GROUPBY_KPI_DROPDOWN_CHANGE = 'BR_Chart_Groupby_Kpi_Dropdown_Change';
export const BUMP_REPORT_PC_ADD_GROUP_A_CLICKED = 'BR_PC_Add_Group_A_Clicked';
export const BUMP_REPORT_PC_ADD_GROUP_B_CLICKED = 'BR_PC_Add_Group_B_Clicked';
export const BUMP_REPORT_PC_ADD_GROUP_A_EDIT_CLICKED = 'BR_PC_Add_Group_A_Edit_Clicked';
export const BUMP_REPORT_PC_ADD_GROUP_B_EDIT_CLICKED = 'BR_PC_Add_Group_B_Edit_Clicked';

//PRICE CHANGE ANALYSIS EVENTS
export const PRICE_CHANGE_SUB_FILTER_SELECTED = 'PCG_Sub_Filter_Selected';
export const PRICE_CHANGE_SUB_FILTER_DESELECTED = 'PCG_Sub_Filter_Deselected';
export const PRICE_CHANGE_SWITCH_CHANGED = 'PCG_Switch_Changed';
export const PRICE_CHANGE_CHART_DRILLDOWN_CLICKED = 'PCG_Chart_Clicked';
export const PRICE_CHANGE_CHART_EXPLORE_MORE_CLICKED = 'PCG_Chart_Explore_More_Clicked';
export const PRICE_CHANGE_COMPARE_CLICKED = 'PCG_Compare_Clicked';
export const PRICE_CHANGE_BASELINE_DROPDOWN_CHANGED = 'PCG_Baseline_Dropdown_Changed';
export const PRICE_CHANGE_PRICE_DROPDOWN_CHANGED = 'PCG_Kpi_Dropdown_Changed';
export const PRICE_CHANGE_TAB_CHANGED = 'PCG_Tab_Changed';
export const PRICE_CHANGE_CHART_COPY = 'PCG_Chart_Copy';
export const PRICE_CHANGE_TABLE_COPY = 'PCG_Table_Copy';
export const PRICE_CHANGE_CHART_EXPORT = 'PCG_Chart_Export';
export const PRICE_CHANGE_TABLE_EXPORT = 'PCG_Table_Export';

//PRICE POINT EVENTS
export const PRICE_POINT_ATTRIBUTE_TYPE_DROPDOWN_CHANGED = 'PP_Attribute_Type_Dropdown_Changed';
export const PRICE_POINT_ATTRIBUTE_NAME_DROPDOWN_CHANGED = 'PP_Attribute_Name_Dropdown_Changed';
export const PRICE_POINT_VALUE_DROPDOWN_CHANGED = 'PP_Value_Dropdown_Changed';
export const PRICE_POINT_PRICE_TYPE_DROPDOWN_CHANGED = 'PP_PriceType_Dropdown_Changed';
export const PRICE_POINT_TAB_CHANGED = 'PP_Tab_Changed';
export const PRICE_POINT_CHART_CLICKED = 'PP_Chart_Clicked';
export const PRICE_POINT_TABLE_ROW_EXPANDED = 'PP_Table_Row_Expanded';
export const PRICE_POINT_REDEFINE_THRESHOLD_CLICKED = 'PP_Redefine_Threshold_Clicked';
export const PRICE_POINT_REDEFINE_THRESHOLD_SLIDER_CHANGED = 'PP_RT_Slider_Changed';
export const PRICE_POINT_REDEFINE_THRESHOLD_SCALE_CHANGED = 'PP_RT_Scale_Changed';
export const PRICE_POINT_REDEFINE_THRESHOLD_TOGGLED = 'PP_RT_Custom_Threshold_Toggled';
export const PRICE_POINT_REDEFINE_THRESHOLD_CUSTOM_THRESHOLD_CHANGED = 'PP_RT_Custom_Threshold_Changed';
export const PRICE_POINT_REDEFINE_THRESHOLD_CUSTOM_THRESHOLD_ADD_MORE_CLICKED =
    'PP_RT_Custom_Threshold_Add_More_Clicked';
export const PRICE_POINT_REDEFINE_THRESHOLD_APPLY_CLICKED = 'PP_RT_Apply_Clicked';
export const PRICE_POINT_REDEFINE_THRESHOLD_RESET_CLICKED = 'PP_RT_Reset_Clicked';

//PRICE TRACKING EVENTS
export const PRICE_TRACKING_TIME_PERIOD_DROPDOWN_CHANGED = 'PT_Time_Period_Dropdown_Changed';
export const PRICE_TRACKING_ROWS_DROPDOWN_CHANGED = 'PT_Rows_Dropdown_Changed';
export const PRICE_TRACKING_COLUMNS_DROPDOWN_CHANGED = 'PT_Columns_Dropdown_Changed';
export const PRICE_TRACKING_WEEKS_DROPDOWN_CHANGED = 'PT_Weeks_Dropdown_Changed';
export const PRICE_TRACKING_PRICE_TYPE_DROPDOWN_CHANGED = 'PT_Price_Type_Dropdown_Changed';
export const PRICE_TRACKING_KPI_DROPDOWN_CHANGED = 'PT_Kpi_Dropdown_Changed';
export const PRICE_TRACKING_CUSTOM_TIME_PERIOD_CLICKED = 'PT_Custom_Time_Period_Clicked';
export const PRICE_TRACKING_TABLE_ROW_EXPANDED = 'PT_Table_Row_Expanded';

//PRICE CURVE EVENTS
export const PRICE_CURVE_X_AXIS_DROPDOWN_CHANGED = 'PCV_X_Axis_Dropdown_Changed';
export const PRICE_CURVE_Y_AXIS_DROPDOWN_CHANGED = 'PCV_Y_Axis_Dropdown_Changed';
export const PRICE_CURVE_LEVELS_DROPDOWN_CHANGED = 'PCV_Levels_Dropdown_Changed';
export const PRICE_CURVE_TAB_CHANGED = 'PCV_Tab_Changed';
export const PRICE_CURVE_CHART_LEGEND_CLICKED = 'PCV_Chart_Legend_Clicked';
export const PRICE_CURVE_CHART2_CLICKED = 'PCV_Chart2_Clicked';

//PRICE LADDER EVENTS
export const PRICE_LADDER_CHART1_DROPDOWN_CHANGED = 'PL_Chart1_Dropdown_Changed';
export const PRICE_LADDER_CHART1_TAB_CHANGED = 'PL_Chart1_Tab_Changed';
export const PRICE_LADDER_CHART1_LEGEND_CLICKED = 'PL_Chart1_Legend_Clicked';
export const PRICE_LADDER_CHART2_DROPDOWN_CHANGED = 'PL_Chart2_Dropdown_Changed';
export const PRICE_LADDER_CHART3_DROPDOWN_CHANGED = 'PL_Chart3_Dropdown_Changed';

//OPPORTUNITY IDENTIFICATION EVENTS
export const OPPORTUNITY_IDENTIFICATION_TAB_CHANGED = 'OI_Tab_Changed';
export const OPPORTUNITY_IDENTIFICATION_BUBBLE_COLOR_DROPDOWN_CHANGED = 'OI_EC_Bubble_Color_Dropdown_Changed';
export const OPPORTUNITY_IDENTIFICATION_X_AXIS_DROPDOWN_CHANGED = 'OI_EC_X_Axis_Dropdown_Changed';
export const OPPORTUNITY_IDENTIFICATION_Y_AXIS_DROPDOWN_CHANGED = 'OI_EC_Y_Axis_Dropdown_Changed';
export const OPPORTUNITY_IDENTIFICATION_BUBBLE_SIZE_DROPDOWN_CHANGED = 'OI_EC_Bubble_Size_Dropdown_Changed';
export const OPPORTUNITY_IDENTIFICATION_DETAILS_TOGGLED = 'OI_EC_Chart_Details_Toggled';
export const OPPORTUNITY_IDENTIFICATION_CHART_EXPORT = 'OI_EC_Chart_Export';
export const OPPORTUNITY_IDENTIFICATION_CHART_COPY = 'OI_EC_Chart_Copy';
export const OPPORTUNITY_IDENTIFICATION_LEVELS_DROPDOWN_CHANGED = 'OI_ED_Levels_Dropdown_Changed';
export const OPPORTUNITY_IDENTIFICATION_SUB_LEVELS_DROPDOWN_CHANGED = 'OI_ED_Sub_Levels_Dropdown_Changed';
export const OPPORTUNITY_IDENTIFICATION_CHART1_VALUE_SELECTED = 'OI_ED_Chart1_Value_Selected';
export const OPPORTUNITY_IDENTIFICATION_CHART2_VALUE_SELECTED = 'OI_ED_Chart2_Value_Selected';
export const OPPORTUNITY_IDENTIFICATION_CHART_LEGEND_CLICKED = 'OI_EC_Chart_Legend_Clicked';
export const OPPORTUNITY_IDENTIFICATION_CHART_LEGEND_DROPDOWN_CLICKED = 'OI_EC_Chart_Legend_More_Clicked';

//PROMO LANDSCAPE EVENTS
export const PROMO_LANDSCAPE_INVESTMENT_DROPDOWN_CHANGED = 'PL_Investment_Dropdown_Changed';
export const PROMO_LANDSCAPE_PROMO_DROPDOWN_CHANGED = 'PL_Promo_Dropdown_Changed';
export const PROMO_LANDSCAPE_ATTRIBUTE_TYPES_DROPDOWN_CHANGED = 'PL_Attribute_Type_Dropdown_Changed';
export const PROMO_LANDSCAPE_TABLE_TAB_CHANGED = 'PL_Table_Tab_Changed';
export const PROMO_LANDSCAPE_CHART_COPY = 'PL_Chart_Copy';
export const PROMO_LANDSCAPE_CHART_EXPORT = 'PL_Chart_Export';
export const PROMO_LANDSCAPE_TABLE_COPY = 'PL_Table_Copy';
export const PROMO_LANDSCAPE_TABLE_ROW_EXPANDED = 'PL_Table_Row_Expanded';

//PORTFOLIO ANALYSIS EVENTS
export const PORTFOLIO_ANALYSIS_SELECT_TAB_CLICKED = 'PA_Main_Tab_Changed';
export const PORTFOLIO_ANALYSIS_TABLE_MICRO_INTERACTION = 'PA_Table_Copy';
export const PORTFOLIO_ANALYSIS_TABLE_MICRO_INTERACTION_EXPORT = 'PA_Table_Export';
export const PORTFOLIO_ANALYSIS_TABLE_HEADER_MECHANICS_FILTER = 'PA_Table_Header_Mechanics_Dropdown_Changed';
export const PORTFOLIO_ANALYSIS_TABLE_HEADER_TACTICS_FILTER = 'PA_Table_Header_Tactics_Dropdown_Changed';
export const PORTFOLIO_ANALYSIS_CHART_GROUPBY_DROPDOWN_CHANGED = 'PA_Chart_Groupby_Dropdown_Changed';
export const PORTFOLIO_ANALYSIS_CHART_BUBBLE_COLOR_DROPDOWN_CHANGED = 'PA_Chart_Bubble_Color_Dropdown_Changed';
export const PORTFOLIO_ANALYSIS_CHART_X_AXIS_DROPDOWN_CHANGED = 'PA_Chart_X_Axis_Dropdown_Changed';
export const PORTFOLIO_ANALYSIS_CHART_Y_AXIS_DROPDOWN_CHANGED = 'PA_Chart_Y_Axis_Dropdown_Changed';
export const PORTFOLIO_ANALYSIS_CHART_BUBBLE_SIZE_DROPDOWN_CHANGED = 'PA_Chart_Bubble_Size_Dropdown_Changed';
export const PORTFOLIO_ANALYSIS_CHART_DETAILS_TOGGLED = 'PA_CDA_Chart_Details_Toggled';
export const PORTFOLIO_ANALYSIS_CHART_COPY = 'PA_CDA_Chart_Copy';
export const PORTFOLIO_ANALYSIS_CHART_EXPORT = 'PA_CDA_Chart_Export';
export const PORTFOLIO_ANALYSIS_CHART_LEGEND_CLICKED = 'PA_CDA_Chart_Legend_Clicked';
export const PORTFOLIO_ANALYSIS_CHART_LEGEND_DROPDOWN_CLICKED = 'PA_CDA_Chart_Legend_More_Clicked';
export const PORTFOLIO_ANALYSIS_MEDIA_SPENDS_ATTRIBUTE_CHANGED = 'PA_Media_spends_attribute_changed';
export const PORTFOLIO_ANALYSIS_MEDIA_SPENDS_MEDIA_TYPES_CHANGED = 'PA_Media_spends_Media_Types_changed';

//PVM Analysis
export const PVM_ANALYSIS_FACTOR_CLICKED = 'PVM_Factor_Clicked';
export const PVM_ANALYSIS_SUB_FACTOR_CLICKED = 'PVM_Sub_Factor_Clicked';
export const PVM_ANALYSIS_CATEGORY_DROP_DOWN_CLICKED = 'PVM_Category_Drop_Down_Clicked';
export const PVM_ANALYSIS_PLAN_SELECTED = 'PVM_Plan_Selected';
export const PVM_ANALYSIS_MONTH_SELECTED = 'PVM_Month_Selected';
export const PVM_ANALYSIS_DRILL_DOWN_DIM_SELECTED = 'PVM_Drill_Down_Dim_Selected';
export const PVM_ANALYSIS_DRILL_DOWN_DIM_VALUE_SELECTED = 'PVM_Drill_Down_Dim_Value_Selected';
export const PVM_ANALYSIS_COPY_SCREENSHOT = 'PVM_Copy_Screenshot';
export const PVM_ANALYSIS_DOWNLOAD_DATA = 'PVM_Download_Data';
export const PVM_ANALYSIS_ORDER_BY_VALUE_CLICKED = 'PVM_Order_By_Value_Clicked';
export const PVM_ANALYSIS_ABSOLUTE_PERCENTAGE_TOGGLE_CLICKED = 'PVM_Absolute_Percentage_Toggle_Clicked';

//PROMO SCORE CARD EVENTS
export const PROMO_SCORECARD_QUESTION_CLICKED = 'PS_Question_Clicked';
export const PROMO_SCORECARD_SELECT_LEVEL_DROPDOWN_CHANGED = 'PS_Select_Level_Dropdown_Changed';
export const PROMO_SCORECARD_SELECT_VARIABLE_DROPDOWN_CHANGED = 'PS_Select_Variable_Dropdown_Changed';
export const PROMO_SCORECARD_SELECT_VARIABLE_DROPDOWN_SEARCHED = 'PS_Select_Variable_Searched';
export const PROMO_SCORECARD_QUESTION_ROW_EXPANDED = 'PS_Question_Row_Expanded';
export const PROMO_SCORECARD_DRILLDOWN_PRODUCT_DETAILS_DROPDOWN_CLICKED = 'PS_Product_Details_Dropdown_Changed';
export const PROMO_SCORECARD_QUESTIONS_COPY = 'PS_Questions_Copy';
export const PROMO_SCORECARD_QUESTIONS_EXPORT = 'PS_Questions_Export';
export const PROMO_SCORECARD_TABLE_COPY = 'PS_Table_Copy';
export const PROMO_SCORECARD_TABLE_EXPORT = 'PS_Table_Export';

//PROMO RECOMMENDATION EVENTS
export const PROMO_RECOMMENDATION_MAIN_TAB_CHANGED = 'PR_Main_Tab_Changed';
export const PROMO_RECOMMENDATION_SELECT_SCENARIO_DROPDOWN_CHANGED = 'PR_Select_Scenario_Dropdown_Changed';
export const PROMO_RECOMMENDATION_NEW_SCENARIO_SELECTED = 'PR_New_Scenario_Selected';
export const PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED = 'PR_New_Scenario_Name_Input_Added';
export const PROMO_RECOMMENDATION_ADD_EVENT_CLICKED = 'PR_Add_Event_Clicked';
export const PROMO_RECOMMENDATION_ADD_EVENT_PRODUCT_SELECT_DROPDOWN_CHANGED = 'PR_AE_Product_Select_Dropdown_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_PRODUCT_SELECTED_REMOVED = 'PR_AE_Product_Selected_Removed';
export const PROMO_RECOMMENDATION_ADD_EVENT_EDIT_PRODUCT_OPEN_INPUT = 'PR_AE_Edit_Product_Open_Input_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_EDIT_PRODUCT_OPEN_INPUT = 'PR_MOD_Edit_Product_Open_Input_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_EDIT_PRODUCT_SHIPPER_INPUT = 'PR_AE_Edit_Product_Shipper_Input_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_EDIT_PRODUCT_SHIPPER_INPUT = 'PR_MOD_Edit_Product_Shipper_Input_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_OFFER_DROPDOWN_CHANGED = 'PR_AE_Offer_Dropdown_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_OFFER_DROPDOWN_CHANGED = 'PR_MOD_Offer_Dropdown_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_OFFER_TYPE_DROPDOWN_CHANGED = 'PR_AE_Offer_Type_Dropdown_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_OFFER_TYPE_DROPDOWN_CHANGED = 'PR_MOD_Offer_Type_Dropdown_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_DATE_SELECTED = 'PR_AE_Date_Selected';
export const PROMO_RECOMMENDATION_EDIT_EVENT_DATE_SELECTED = 'PR_MOD_Date_Selected';
export const PROMO_RECOMMENDATION_ADD_EVENT_DURATION_CHANGED = 'PR_AE_Duration_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_DURATION_CHANGED = 'PR_MOD_Duration_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_DISPLAY_ACV_CHANGED = 'PR_AE_Display_Acv_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_DISPLAY_ACV_CHANGED = 'PR_MOD_Display_Acv_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_FEATURE_ACV_CHANGED = 'PR_AE_Feature_Acv_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_FEATURE_ACV_CHANGED = 'PR_MOD_Feature_Acv_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_BASELINE_VOLUME_CHANGED = 'PR_AE_Baseline_Volume_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_BASELINE_VOLUME_CHANGED = 'PR_MOD_Baseline_Volume_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_UPLIFT_CHANGED = 'PR_AE_Uplift_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_UPLIFT_CHANGED = 'PR_MOD_Uplift_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_SPENDS_DROPDOWN_CHANGED = 'PR_AE_Spends_Dropdown_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_SPENDS_DROPDOWN_CHANGED = 'PR_MOD_Spends_Dropdown_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_SPENDS_INPUT_CHANGED = 'PR_AE_Spends_Input_Changed';
export const PROMO_RECOMMENDATION_EDIT_EVENT_SPENDS_INPUT_CHANGED = 'PR_MOD_Spends_Input_Changed';
export const PROMO_RECOMMENDATION_ADD_EVENT_RESET_CLICKED = 'PR_AE_Reset_Clicked';
export const PROMO_RECOMMENDATION_ADD_EVENT_APPLY_CLICKED = 'PR_AE_Apply_Clicked';
export const PROMO_RECOMMENDATION_EDIT_EVENT_APPLY_CLICKED = 'PR_MOD_Apply_Clicked';
export const PROMO_RECOMMENDATION_SAVE_SCENARIO_CLICKED = 'PR_Save_Scenario_Clicked';
export const PROMO_RECOMMENDATION_EDIT_EVENT_CLICKED = 'PR_Edit_Event_Clicked';
export const PROMO_RECOMMENDATION_DELETE_EVENT_CLICKED = 'PR_Delete_Event_Clicked';
export const PROMO_RECOMMENDATION_CALENDER_KPI_TAB_CHANGED = 'PR_Calender_Kpi_Tab_Changed';
export const PROMO_RECOMMENDATION_BAR_SLIDER_CHANGED = 'PR_Calender_Time_Slider_Changed';
export const PROMO_RECOMMENDATION_SUMMARY_DROPDOWN_CHANGED = 'PR_Summary_Dropdown_Changed';

//CRASH SCREEN ERROR EVENTS
export const ERROR_EVENTS = 'Error_Events';
export const XLSX_EXPORT_ERROR = 'Xlsx_Export_Error';

// PRICE SIMULATION EVENTS
export const PSR_DATE_RANGE_CHANGED = 'Psr_Date_Range_Changed';
export const PSR_DATA_SOURCE_CHANGED = 'Psr_Data_Source_Changed';
export const PSR_PRICE_EFFECTIVE_DATE_CHANGED = 'Psr_Price_Effec_Date_Changed';
export const PSR_KPI_GOALS_INPUT_VALUE_CHANGED = 'Psr_KPI_GOALS_Input_Val_Changed';
export const PSR_KPI_GOALS_PERCENTAGE_VALUE_CHANGED = 'Psr_KPI_GOALS_Percentage_Val_Changed';
export const PSR_ADD_MORE_KPI_CLICKED = 'Psr_ADD_MORE_KPI_Clicked';
export const PSR_NAME_UPDATED = 'Psr_NAME_UPDATED';
export const PSR_PROTFOLIO_SUBMIT_BTN_CLICKED = 'Psr_Portfolio_Submit_Btn_Clicked';
export const PSR_PROTFOLIO_CELL_CLICKED = 'Psr_Portfolio_Cell_Clicked';
export const PSR_PROTFOLIO_ADD_CELL_CLICKED = 'Psr_Portfolio_Add_Cell_Clicked';
export const PSR_PROTFOLIO_ADD_CELL_INPUT_VALUE_CHANGED = 'Psr_Portfolio_Add_Cell_Input_Value_Changed';
export const PSR_PROTFOLIO_ADD_CELL_INPUT_PERCENTAGE_CHANGED = 'Psr_Portfolio_Add_Cell_Input_Percentage_Changed';
export const PSR_PROTFOLIO_ADD_CELL_LEVEL1_DP_CHANGED = 'Psr_Portfolio_Add_Cell_Level1_Dp_Changed';
export const PSR_PROTFOLIO_ADD_CELL_LEVEL2_DP_CHANGED = 'Psr_Portfolio_Add_Cell_Level2_Dp_Changed';
export const PSR_PROTFOLIO_ACTIVATION_INACTIVATION_POPUP_CLICKED =
    'Psr_Portfolio_Actionation_Inactivation_Popup_Clicked';
export const PSR_PROTFOLIO_INACTIVATION_DATE_CHANGED = 'Psr_Portfolio_Inactivation_Date_Changed';
export const PSR_IDEN_OPPLEVEL1_FILTER_CHANGED = 'Psr_Iden_Opp_LEVEL1_Filter_Changed';
export const PSR_IDEN_OPPLEVEL2_FILTER_CHANGED = 'Psr_Iden_Opp_LEVEL2_Filter_Changed';
export const PSR_IDEN_OPPINPUT_KPI_OPTIONS_DROPDOWN_CHANGED = 'Psr_Iden_Opp_INPUT_KPI_OPTIONS_Dp_Changed';
export const PSR_IDEN_OPPINPUT_TABLE_INPUT_VALUE_CHANGED = 'Psr_Iden_Opp_Inp_Tbl_INPUT_Value_Changed';
export const PSR_IDEN_OPPINPUT_TABLE_INPUT_PERCENTAGE_CHANGED = 'Psr_Iden_Opp_Inp_Tbl_INPUT_Percentage_Changed';
export const PSR_IDEN_OPPINPUT_TABLE_GLOBAL_INPUT_CHANGED = 'Psr_Iden_Opp_Inp_Tbl_GLOBAL_INPUT_Changed';
export const PSR_IDEN_OPPINPUT_TABLE_GLOBAL_COMP_FOLLOW_CHANGED = 'Psr_Iden_Opp_Inp_Tbl_GLOBAL_COMP_FOLLOW_Changed';
export const PSR_IDEN_OPPINPUT_TABLE_COMP_FOLLOW_CHANGED = 'Psr_Iden_Opp_Inp_Tbl_COMP_FOLLOW_Changed';
export const PSR_IDEN_OPPINPUT_TABLE_COPY_EVENT_CLICKED = 'Psr_Iden_Opp_Inp_Tbl_Cpy_Evt_Clicked';
export const PSR_IDEN_OPPINPUT_TABLE_COPY_EVENT_TRIGGERED = 'Psr_Iden_Opp_Inp_Tbl_Cpy_Evt_Triggered';
export const PSR_IDEN_OPPINPUT_TABLE_COPY_EVENT_DROPDOWN_CHANGED = 'Psr_Iden_Opp_Inp_Tbl_Cpy_Evt_Dp_Changed';
export const PSR_NAVIGATION_BUTTON_CLICKED = 'Psr_Navigation_Btn_Clicked';
export const PSR_SIMULATION_BUTTON_CLICKED = 'Psr_Simulation_Btn_Clicked';
export const PSR_CREATE_SCENARIO_BUTTON_CLICKED = 'Psr_Create_Scenario_Btn_Clicked';
export const PSR_COMPARE_SCENARIO_BUTTON_CLICKED = 'Psr_Compare_Scenario_Btn_Clicked';
export const PSR_SELECTION_CHECKBOX_CLICKED = 'Psr_Selection_Checkbox_Clicked';
export const PSR_GLOBAL_TILE_CHANGED = 'PSR_GLOBAL_TILE_Changed';
export const PSR_COPY_EVENT_CLICKED = 'Psr_Cpy_Evt_Clicked';
export const PSR_DELETE_EVENT_CLICKED = 'Psr_Delete_Evt_Clicked';
export const PSR_EDIT_EVENT_CLICKED = 'Psr_Edit_Evt_Clicked';
export const PSR_COMP_VS_ACTUALS_VS_GOALS_TILE_CHANGED = 'Psr_Cmpr_VS_ACTUALS_VS_GOALS_TILE_Changed';
export const PSR_COMP_SELECTE_PLANS_BTN_CLICKED = 'Psr_Cmpr_Select_Plans_Btn_Clicked';
export const PSR_COMP_SELECTE_PLANS_DATA_SOURCE_CHANGED = 'Psr_Cmpr_Select_Plans_Data_Source_Dp_Changed';
export const PSR_COMP_SCENARIO_CARD_CLICKED = 'Psr_Cmpr_Scenario_Card_Clicked';
export const PSR_COMP_MORE_INFO_TILE_CHANGED = 'Psr_Cmpr_More_Info_Tile_Changed';
export const PSR_SIMULATION_FILTER_TOGGLED = 'Psr_Simulation_Filter_Toggled';

//TRADE PROMO OPTIMIZATION EVENTS
export const TPO_APP_LOADED = 'Tpo_App_Loaded';
export const TPO_MAIN_TAB_SELECTED = 'Tpo_Main_Tab_Selected';
export const TPO_PLAN_DETAILS_VIEWED = 'Tpo_Plan_Details_Viewed';
export const TPO_PLAN_DETAILS_SUB_VIEW_CHANGED = 'Tpo_Plan_Details_Sub_View_Changed';
export const TPO_PLAN_DETAILS_OPTIMIZE_PLAN_CLICKED = 'Tpo_Plan_Details_Optimize_Plan_Clicked';
export const TPO_PLAN_COMPARISON_APPLY_CLICKED = 'Tpo_Plan_Comparison_Apply_Clicked';
export const TPO_PLAN_COMPARISON_RESULTS_VIEWED = 'Tpo_Plan_Comparison_Results_Viewed';
export const TPO_TOOLS_SUB_TAB_CHANGED = 'Tpo_Tools_Sub_Tab_Changed';
export const TPO_TOOLS_CELL_EDITED = 'Tpo_Tools_Cell_Edited';
export const TPO_TOOLS_COLUMN_EDITED = 'Tpo_Tools_Column_Edited';
export const TPO_REPORTS_SUB_TAB_CHANGED = 'Tpo_Reports_Sub_Tab_Changed';
export const TPO_REPORTS_BULK_EXPORT_VIEWED = 'Tpo_Reports_Bulk_Export_Viewed';
export const TPO_REPORTS_BULK_EXPORT_CREATE_CLICKED = 'Tpo_Reports_Bulk_Export_Create_Clicked';

// Profit Pool
export const PP_OVERVIEW_CHART_VIEW_TOGGLED = 'ppl_chart_view_toggled';
export const PP_OVERVIEW_UNIT_CHANGED = 'ppl_absolute_percentage_toggled';
export const PP_OVERVIEW_TAB_CHANGED = 'ppl_profit_growth_tab_selected';
export const PP_OVERVIEW_SORTED_BY_GROWTH = 'ppl_brand_sorted_by_growth';
export const PP_EVOLUTION_TIME_GRANULARITY_CHANGED = 'ppl_time_granularity_changed';
export const PP_EVOLUTION_KPI_METRIC_CHANGED = 'ppl_kpi_metric_changed';
export const PP_EVOLUTION_KPI_VIEW_TOGGLED = 'ppl_kpi_view_toggled';
export const PP_GMD_WATERFALL_BAR_CLICKED = 'ppl_waterfall_bar_clicked';
export const PP_GMD_VIEW_BREAKDOWN_CLICKED = 'ppl_view_breakdown_clicked';
export const PP_GMD_DECOMPOSITION_VARIABLE_ADDED = 'ppl_decomposition_variable_added';
export const PP_STRATEGIC_OPPORTUNITY_MODE_CHANGED = 'ppl_strategic_opportunity_mode_changed';
export const PP_STRATEGIC_OPPORTUNITY_SCATTER_DIMENSION_CHANGED = 'ppl_scatter_dimension_changed';
export const PP_STRATEGIC_OPPORTUNITY_COLOR_BY_CHANGED = 'ppl_color_by_changed';
export const PP_STRATEGIC_OPPORTUNITY_ABSOLUTE_PERCENTAGE_TOGGLED = 'ppl_so_absolute_percentage_toggled';
export const PP_STRATEGIC_OPPORTUNITY_DETAILS_TOGGLED = 'ppl_so_details_toggled';

// PPA WHITESPACE ANALYSIS EVENTS
export const PPA_WHITESPACE_VIEWED = 'ppa_whitespace_viewed';
export const PPA_WHITESPACE_DATA_LOAD_SUCCEEDED = 'ppa_whitespace_data_load_succeeded';
export const PPA_WHITESPACE_AXIS_CHANGED = 'ppa_whitespace_axis_changed';
export const PPA_WHITESPACE_OVERLAY_RENDERED = 'ppa_whitespace_overlay_rendered';
export const PPA_WHITESPACE_CHART_LAZY_LOAD_TRIGGERED = 'ppa_whitespace_chart_lazy_load_triggered';
export const PPA_WHITESPACE_CELL_HOVER = 'ppa_whitespace_cell_hover';
export const PPA_WHITESPACE_ENTITY_MORE_CLICKED = 'ppa_whitespace_entity_more_clicked';
export const PPA_WHITESPACE_ENTITY_LIST_COLLAPSED = 'ppa_whitespace_entity_list_collapsed';
export const PPA_WHITESPACE_EXPORT_CLICKED = 'ppa_whitespace_export_clicked';
export const PPA_WHITESPACE_EXPORT_CONFIRMED = 'ppa_whitespace_export_confirmed';
export const PPA_WHITESPACE_EXPORT_SUCCEEDED = 'ppa_whitespace_export_succeeded';
export const PPA_WHITESPACE_EXPORT_FAILED = 'ppa_whitespace_export_failed';
export const PPA_WHITESPACE_SESSION_TIME_SPENT = 'ppa_whitespace_session_time_spent';

// PACK ARCHITECTURE (PPA) EVENTS
export const PPA_PACK_ARCH_VIEWED = 'ppa_pack_arch_viewed';
export const PPA_PACK_ARCH_CHART_RENDERED = 'ppa_pack_arch_chart_rendered';
export const PPA_PACK_ARCH_GLOBAL_FILTER_APPLIED = 'ppa_pack_arch_global_filter_applied';
export const PPA_PACK_ARCH_FILTERED_EMPTY_STATE = 'ppa_pack_arch_filtered_empty_state';
export const PPA_PACK_ARCH_EMPTY_STATE_VIEWED = 'ppa_pack_arch_empty_state_viewed';
export const PPA_PACK_ARCH_CHART_CONFIG_CHANGED = 'ppa_pack_arch_chart_config_changed';
export const PPA_PACK_ARCH_CHART_LAZY_LOAD_TRIGGERED = 'ppa_pack_arch_chart_lazy_load_triggered';
export const PPA_PACK_ARCH_BUBBLE_HOVER = 'ppa_pack_arch_bubble_hover';
export const PPA_PACK_ARCH_TABLE_SECTION_VIEWED = 'ppa_pack_arch_table_section_viewed';
export const PPA_PACK_ARCH_TABLE_SEARCH = 'ppa_pack_arch_table_search';
export const PPA_PACK_ARCH_TABLE_SEARCH_EMPTY = 'ppa_pack_arch_table_search_empty';
export const PPA_PACK_ARCH_TABLE_SCROLLED = 'ppa_pack_arch_table_scrolled';
export const PPA_PACK_ARCH_TABLE_CONFIGURATION_CHANGED = 'ppa_pack_arch_table_configuration_changed';
export const PPA_PACK_ARCH_LEGEND_OR_ROW_SELECTED = 'ppa_pack_arch_legend_or_row_selected';
export const PPA_PACK_ARCH_BUBBLE_OR_CELL_SELECTED = 'ppa_pack_arch_bubble_or_cell_selected';
export const PPA_PACK_ARCH_LEGEND_EXPANDED = 'ppa_pack_arch_legend_expanded';
export const PPA_PACK_ARCH_LEGEND_OTHER_EXPANDED = 'ppa_pack_arch_legend_other_expanded';
export const PPA_PACK_ARCH_ZOOM_CHANGED = 'ppa_pack_arch_zoom_changed';
export const PPA_PACK_ARCH_HEATMAP_ENABLED = 'ppa_pack_arch_heatmap_enabled';
export const PPA_PACK_ARCH_HEATMAP_FILTERED_VIEW_USED = 'ppa_pack_arch_heatmap_filtered_view_used';

// Shared axis-config events (used by both PPA + Whitespace contexts)
export const PPA_DIMENSION_AXIS_CONFIG_RESET = 'ppa_dimension_axis_config_reset';
export const PPA_DIMENSION_AXIS_CONFIG_CANCELLED = 'ppa_dimension_axis_config_cancelled';
export const PPA_DIMENSION_AXIS_CONFIG_APPLIED = 'ppa_dimension_axis_config_applied';
export const PPA_KPI_AXIS_CONFIG_RESET = 'ppa_kpi_axis_config_reset';
export const PPA_KPI_AXIS_CONFIG_CANCELLED = 'ppa_kpi_axis_config_cancelled';
export const PPA_KPI_AXIS_CONFIG_APPLIED = 'ppa_kpi_axis_config_applied';
export const PPA_PACK_ARCH_EXPORT_CLICKED = 'ppa_pack_arch_export_clicked';
export const PPA_PACK_ARCH_EXPORT_CONFIRMED = 'ppa_pack_arch_export_confirmed';
export const PPA_PACK_ARCH_EXPORT_SUCCEEDED = 'ppa_pack_arch_export_succeeded';
export const PPA_PACK_ARCH_EXPORT_FAILED = 'ppa_pack_arch_export_failed';
export const PPA_PACK_ARCH_PAGE_TIME_SPENT = 'ppa_pack_arch_page_time_spent';

// Ask Asper (agentic) — event names aligned with asper_design_library / ddai_fe
// Top nav global AskAsper button (fires both events, matching ddai_fe Navbar)
export const TOP_NAV_ASKASPER_CLICK = 'top_nav_askasper_click';
export const ASK_ASPER_GLOBAL_ICON_CLICK = 'ask_asper_global_icon_click';
export const ASK_ASPER_SESSION_START = 'ask_asper_session_start';
export const ASK_ASPER_SESSION_END = 'ask_asper_session_end';

/** Reasons an Ask Asper page session ends; sent as `end_reason` on ASK_ASPER_SESSION_END. */
export const ASK_ASPER_SESSION_END_REASON = {
    LOGOUT: 'logout',
    BROWSER_CLOSE: 'browser_close',
    AUTH_TIMEOUT: 'auth_timeout',
    NAVIGATE: 'navigate',
} as const;

export type AskAsperSessionEndReason =
    (typeof ASK_ASPER_SESSION_END_REASON)[keyof typeof ASK_ASPER_SESSION_END_REASON];
export const ASK_ASPER_COMPOSER_SLASH_COMMAND_OPTION_SELECT = 'ask_asper_composer_slash_command_option_select';
export const ASK_ASPER_COMPOSER_ENTITY_FILTER_ITEM_SELECT = 'ask_asper_composer_entity_filter_item_select';
export const ASK_ASPER_COMPOSER_ENTITY_FILTER_ITEM_DESELECT = 'ask_asper_composer_entity_filter_item_deselect';
export const ASK_ASPER_COMPOSER_TIME_PERIOD_SELECT = 'ask_asper_composer_time_period_select';
export const ASK_ASPER_COMPOSER_QUERY_SEND_WITH_SLASH_FILTERS = 'ask_asper_composer_query_send_with_slash_filters';

// Right-panel artefact export option clicks (fired by asper_design_library for every format,
// including client-side Word/PDF/PPT/current-view Excel — not only host-handled xlsx).
export const ASK_ASPER_ARTEFACT_EXPORT_OPTION_CLICK = 'ask_asper_artefact_export_option_click';
export const ASK_ASPER_MULTI_SELECT_EXPORT_OPTION_CLICK = 'ask_asper_multi_select_export_option_click';
